import * as React from "react";
const SvgEie = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 35" {...props}><path fill="currentColor" d="M0 0h37.8v4.6H21.4v10.1h11.4v4.4H21.4v11.1h16.4V35H0v-4.8h16.4V19.1H5v-4.4h11.4V4.6H0z" /></svg>;
export default SvgEie;